
import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'

@Observer
@Component({
  components: { HeaderImage }
})
export default class NavBar extends Vue {
  @Prop({ required: true }) courseId: string
  @Prop({ default: false, required: false, type: Boolean }) custmBack: boolean

  get StatisticsData() {
    return this.$store.$courseV2.StatisticsData
  }

  get CourseInfo() {
    return this.$store.$courseV2.courseInfo
  }

  get ProductInfo() {
    return this.$store.$courseV2.productInfo
  }

  async fetchData() {
    await this.$store.$courseV2.StatisticsData.getUserLearnData(this.courseId)
  }

  handleClickBack() {
    if (this.custmBack) {
      this.$emit('go-back')
    } else {
      this.$router.back()
    }
  }

  created() {}
  mounted() {
    this.fetchData()
  }
  updated() {}
  destroyed() {}
}
